<template>
  <div class="container-root h-100 relative">
    <Breadcrumb :items.sync="breadcrumb"></Breadcrumb>
    <div v-if="breadcrumb.length === 1">
      <div class="header-group">
        <h2 style="margin: 0px; font-weight: bold">STAFF DETAILS</h2>
        <div class="btn-group">
          <button class="button green-col" @click="showArchive()">
            <div>ARCHIVE</div>
          </button>
          <button
            class="button dark-blue"
            @click="breadcrumb.push({ text: 'Add Employee' })"
          >
            <i
              style="margin-right: 5px; margin-top: 1px"
              class="fas fa-plus"
            ></i>
            <div>ADD EMPLOYEE</div>
          </button>
        </div>
      </div>
      <div style="margin-top: 25px">
        <Table
          :title="'Staff'"
          :model="list.table"
          :isLoading="list.isLoading"
          :selectedId.sync="selectedId"
          :filterIndex="1"
        >
          <button
            class="button-square"
            @click="download"
            v-if="!list.isLoading"
          >
            <div style="text-align: center">DOWNLOAD</div>
          </button>
        </Table>
      </div>
    </div>
    <template v-if="breadcrumb.length === 2">
      <StaffDetails
        v-if="breadcrumb[1].text !== 'Archived Employee'"
        :profile="profile"
        :id.sync="details.id"
        :title.sync="details.title"
        :banks="banks"
      ></StaffDetails>
      <Table
        v-else
        :selectedId.sync="selectedArchiveId"
        :title="'Archive'"
        :model="archive.table"
        :isLoading="archive.isLoading"
        :actions="archive.actions"
        @onAction="onArchiveAction"
      ></Table>
    </template>
    <Notif v-if="notif" :data.sync="notif"></Notif>
    <div
      v-if="showArchiveDetails"
      class="absolute flex flex-column h-100 w-100 top-0 left-0 bg-white pa2"
    >
      <div class="flex justify-between pt2">
        <div
          class="shadow-hover dark-red"
          @click="
            showArchiveDetails = false;
            selectedArchiveId = -1;
          "
        >
          Back
        </div>
        <div class="b">{{ selectedArchiveEmployee.name }}</div>
      </div>
      <div class="flex flex-wrap mt2 dark-gray">
        <div class="flex flex-column pa2 ba b--light-gray w-100 w-50-ns">
          <div class="flex justify-between">
            <div>Name</div>
            <div>{{ selectedArchiveEmployee.name }}</div>
          </div>
          <div class="flex justify-between">
            <div>Gender</div>
            <div>{{ selectedArchiveEmployee.gender }}</div>
          </div>
          <div class="flex justify-between">
            <div>Date of Birth</div>
            <div>{{ formatDate(selectedArchiveEmployee.dob) }}</div>
          </div>
          <div class="flex justify-between">
            <div>Employee No</div>
            <div>{{ selectedArchiveEmployee.employee_no }}</div>
          </div>
          <div class="flex justify-between">
            <div>Employee Type</div>
            <div>{{ selectedArchiveEmployee.employee_type }}</div>
          </div>
          <div class="flex justify-between">
            <div>Job Category</div>
            <div>{{ selectedArchiveEmployee.job_category }}</div>
          </div>
          <div class="flex justify-between">
            <div>Highest Education</div>
            <div>{{ selectedArchiveEmployee.highest_education }}</div>
          </div>
          <div class="flex justify-between">
            <div>BPJS Kesehatan</div>
            <div>{{ selectedArchiveEmployee.bpjs_kesehatan_no }}</div>
          </div>
          <div class="flex justify-between">
            <div>BPJS Ketenagakerjaan</div>
            <div>{{ selectedArchiveEmployee.bpjs_tenaker_no }}</div>
          </div>
          <div class="flex justify-between">
            <div>ID Number</div>
            <div>{{ selectedArchiveEmployee.identity_no }}</div>
          </div>
          <div class="flex justify-between">
            <div>Department</div>
            <div>{{ selectedArchiveEmployee.department }}</div>
          </div>
        </div>
        <div class="flex flex-column pa2 ba b--light-gray w-100 w-50-ns">
          <div class="flex justify-between">
            <div>Salary</div>
            <div>{{ selectedArchiveEmployee.salary }}</div>
          </div>
          <div class="flex justify-between">
            <div>Food and Transport</div>
            <div>{{ selectedArchiveEmployee.food_transport_allowance }}</div>
          </div>
          <div class="flex justify-between">
            <div>Functional Allowance</div>
            <div>{{ selectedArchiveEmployee.functional_allowance }}</div>
          </div>
          <div class="flex justify-between">
            <div>BPJS Ketenagakerjaan School Contrib</div>
            <div>{{ selectedArchiveEmployee.bpjs_tenaker_school_contrib }}</div>
          </div>
          <div class="flex justify-between">
            <div>BPJS Ketenagakerjaan Staff Contrib</div>
            <div>{{ selectedArchiveEmployee.bpjs_tenaker_staff_contrib }}</div>
          </div>
          <div class="flex justify-between">
            <div>BPJS Kesehatan School Contrib</div>
            <div>
              {{ selectedArchiveEmployee.bpjs_kesehatan_school_contrib }}
            </div>
          </div>
          <div class="flex justify-between">
            <div>BPJS Kesehatan Staff Contrib</div>
            <div>
              {{ selectedArchiveEmployee.bpjs_kesehatan_staff_contrib }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { utils, http } from '../digilib_web/core/digitify';
import XLSX from 'xlsx';
import Table from '../digilib_web/vue/table';
import Breadcrumb from '../digilib_web/vue/breadcrumb';
import StaffDetails from './staff_details';
import Notif from '../digilib_web/vue/notif';
import dayjs from 'dayjs';

export default {
  props: {
    profile: Object
  },
  watch: {
    breadcrumb: {
      handler(n) {
        // reset data when home
        if (n.length === 1) {
          this.details = { id: -1, title: 'Add Employee' };
          this.reloadTable();
        }
      }
    },
    selectedId: {
      handler(id) {
        if (id > -1) {
          let selectedEmployee = this.list.employees.find(x => x.id === id);
          // set the details props
          this.details = {
            id: selectedEmployee.id,
            title: selectedEmployee.name
          };
          // set the breadcrumb
          this.breadcrumb.push({ text: 'Staff Details' });
          // reset the selected idx
          this.selectedId = -1;
        }
      }
    },
    selectedArchiveId: {
      handler(id) {
        if (id > -1) {
          if (id > -1) {
            this.selectedArchiveEmployee = this.archive.data.find(
              x => x.id === id
            );
            // console.log(this.selectedArchiveEmployee);
            this.showArchiveDetails = true;
          }
        }
      }
    }
  },
  methods: {
    formatDate(str) {
      return dayjs(str).format('DD MMM YYYY');
    },
    reloadTable() {
      this.list.isLoading = true;
      // get the list of the banks then
      http.get('banks').then(json => {
        this.banks = json.data;
        http.get('employees?where=is_archived,=,false').then(json => {
          this.list.isLoading = false;
          this.list.employees = json.data.filter(
            x => !x.roles.includes('Tester')
          );
          // this.list.employees = json.data;
          // generate the table data
          this.list.table = utils.toTable(this.list.employees, {
            name: { title: 'name' },
            department: { title: 'department' },
            employee_no: { title: 'employee number' }
          });
        });
      });
    },
    download() {
      let data = [];
      for (let i = 0; i < this.list.employees.length; ++i) {
        let e = this.list.employees[i];
        data.push({
          Name: e.name,
          'Employee No': e.employee_no,
          'Employee Type': e.employee_type,
          'Job Category': e.job_category,
          'Phone Number': e.phone_no,
          Department: e.department,
          Address: e.addresses ? e.addresses[0] : null,
          Email: e.emails ? e.emails[0] : null,
          'Bank Account No': e.bank_acc_no,
          'Date of Birth': e.dob,
          'Place of Birth': e.pob,
          Religion: e.religion,
          Institution: e.institution,
          'Highest Education': e.highest_education,
          Gender: e.gender,
          Expat: e.is_expat ? 'Yes' : 'No'
        });
      }
      let ws = XLSX.utils.json_to_sheet(data);
      let wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'employees');
      XLSX.writeFile(wb, 'employees.xlsx');
    },
    showArchive() {
      this.breadcrumb.push({ text: 'Archived Employee' });
      this.reloadArchive();
    },
    reloadArchive() {
      this.archive.isLoading = true;
      let endpoint = 'employees?where=is_archived,=,true';
      http.get(endpoint).then(json => {
        this.archive.isLoading = false;
        this.archive.data = json.data;
        // generate the table data
        this.archive.table = utils.toTable(this.archive.data, {
          name: { title: 'name' },
          department: { title: 'department' },
          employee_no: { title: 'employee number' }
        });
      });
    },
    onArchiveAction(action, itemId) {
      console.log(action);

      this.archive.isLoading = true;
      let payload = { is_archived: false };
      let endpoint = `employees/${itemId}`;
      http.put(endpoint, payload).then(json => {
        this.archive.isLoading = false;
        this.notif = utils.notif('Employee restored!', json);
        if (json.success) {
          this.reloadArchive();
        }
      });
    }
  },
  mounted() {
    this.reloadTable();
  },
  data() {
    return {
      selectedArchiveEmployee: null,
      showArchiveDetails: false,
      notif: null,
      selectedArchiveId: -1,
      selectedId: -1,
      banks: [],
      list: {
        isLoading: false,
        employees: [],
        table: {}
      },
      details: {
        id: -1,
        title: 'Add Employee'
      },
      archive: {
        isLoading: false,
        table: {},
        data: [],
        actions: ['Accept']
      },
      breadcrumb: [{ icon: 'fa fa-home', text: 'Staff' }]
    };
  },
  components: {
    Table,
    Breadcrumb,
    StaffDetails,
    Notif
  }
};
</script>

<style scoped>
.header-group {
  display: flex;
  justify-content: space-between;
}
.btn-group {
  display: flex;
  /* flex-flow: row; */
  justify-content: space-between;
}
.btn-group > button:not(:last-child) {
  margin-right: 10px;
}
@media all and (max-width: 768px) {
  .header-group {
    flex-flow: column;
  }
  .btn-group > button:not(:last-child) {
    margin-right: 0;
  }
}
</style>
